// ConfirmDialog
import { createAction } from "@reduxjs/toolkit"

export const CONFIRM_DIALOG_OPEN = createAction("CONFIRM_DIALOG_OPEN")
export const CONFIRM_DIALOG_YES = createAction("CONFIRM_DIALOG_YES")
export const CONFIRM_DIALOG_NO = createAction("CONFIRM_DIALOG_NO")
export const CONFIRM_DIALOG_CLOSE = createAction("CONFIRM_DIALOG_CLOSE")
export const CONFIRM_DIALOG_RESET = createAction("CONFIRM_DIALOG_RESET")

export const show = (message, options) =>
  CONFIRM_DIALOG_OPEN({ message, ...options })

export const reset = () => CONFIRM_DIALOG_RESET()
